<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content d-flex justify-content-center align-items-center flex-column">
      <h4>Đồng bộ với zalo</h4>
      <a class="zalo-btn" rel="noopener noreferrer" href="http://crm.ity.vn/api/zalo/login/" target="_blank">
        <img src="../../assets/icon/zalo.png" alt="logo" height="30" width="30">
        Connect to Zalo
      </a>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ZaloConnect'
}
</script>

<style scoped lang="scss">
  .zalo-btn {
    background-color: #0180C7;
    color: white;
    padding: 20px 10px;
    font-size: 16px;

    &:hover {
       text-decoration: none;
       background-color: #3690c3;
     }
  }
</style>



// WEBPACK FOOTER //
// src/views/social_network/ZaloConnect.vue